require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-ida-19-climate-change-goals.json") })
        }
      }, "path---en-us-update-ida-19-climate-change-goals");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-ida-19-climate-change-goals!./.cache/json/en-us-update-ida-19-climate-change-goals.json
// module id = 745
// module chunks = 231608221292675